import moment from 'moment-timezone';
import 'moment/locale/pt-br';

export const convertDateToISO = (date: string) => {
  const partes = date.split('/');
  return `${partes[2]}-${partes[1]}-${partes[0]}`;
};

const formatDate = (date: any = null) => (date ? moment.utc(date) : moment());

export default formatDate;
